module.exports = __webpack_public_path__ + "static/media/Soon.4076972b.png";